import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AdminAreaRequest } from '../models/area.model';
import { AdminDepartmentRequest } from '../models/department.model';
import { ProfileSalaryRequest } from '../models/profile-salary.model';
import { EmployeeRequest } from '../models/employee.model';

@Injectable({
  providedIn: 'root'
})
export class HumanResourcesService {

  private url = environment.api;

  constructor(private http: HttpClient) { }

  getOrganizationData() {
    return this.http.get(this.url + 'api/erp/payroll/organization/chart');
  }

  getContractsPosition(idPosition: number) {
    return this.http.get(this.url + 'api/erp/payroll/contract/position/' + idPosition);
  }

  addLocation(location: any) {
    return this.http.post(this.url + "api/erp/payroll/organization/location", location);
  }

  getLocations() {
    return this.http.get(this.url + "api/erp/payroll/organization/location");
  }

  getAreasByWarehouse(warehouseId: any) {
    return this.http.get(this.url + "api/erp/payroll/organization/areas?warehouse=" + warehouseId);
  }

  getAllAreas() {
    return this.http.get(this.url + "api/erp/payroll/organization/allAreas");
  }

  getAllDepartments() {
    return this.http.get(this.url + "api/erp/payroll/organization/allDepartments");
  }

  getAllPositions() {
    return this.http.get(this.url + "api/erp/payroll/organization/allPositions");
  }

  getPaymentContractCompany(paymentId:number){
    return this.http.get(this.url + "api/erp/payroll/contract/totalCompany/payment?payment="+paymentId)
  }

  getEmployeeContractArea(areaId:number){
    return this.http.get(this.url + "api/erp/payroll/contract/area/"+areaId)
  }

  /**
   * 
   * @param area { name: string, warehouse:number }
   * @returns 
   */
  createArea(area: AdminAreaRequest) {
    return this.http.post(this.url + "api/erp/payroll/organization/area", area);
  }

  updateArea(areaId: number, updatedArea: AdminAreaRequest) {
    return this.http.put(this.url + "api/erp/payroll/organization/area?id=" + areaId, updatedArea);
  }

  deleteArea(areaId: number) {
    return this.http.delete(this.url + "api/erp/payroll/organization/area?id=" + areaId)
  }

  createDepartment(department: AdminDepartmentRequest) {
    return this.http.post(this.url + "api/erp/payroll/organization/department", department);
  }

  updateDepartment(departmentId: number, updatedDepartment: AdminDepartmentRequest) {
    return this.http.put(this.url + "api/erp/payroll/organization/department?id=" + departmentId, updatedDepartment);
  }

  deleteDepartment(departmentId: number) {
    return this.http.delete(this.url + "api/erp/payroll/organization/department?id=" + departmentId)
  }

  createPosition(position: AdminDepartmentRequest) {
    return this.http.post(this.url + "api/erp/payroll/organization/position", position);
  }

  updatePosition(positionId: number, updatedPosition: AdminDepartmentRequest) {
    return this.http.put(this.url + "api/erp/payroll/organization/position?id=" + positionId, updatedPosition);
  }

  deletePosition(positionId: number) {
    return this.http.delete(this.url + "api/erp/payroll/organization/position?id=" + positionId)
  }

  getProfileContract() {
    return this.http.get(this.url + "api/erp/payroll/contract/profile");
  }

  getPersonalToHire() {
    return this.http.get(this.url + "api/erp/payroll/personal/employees");
  }

  addContractProfile(contractProfile: ProfileSalaryRequest) {
    return this.http.post(this.url + "api/erp/payroll/contract/profile", contractProfile);
  }

  changeImageEmployee(idEmployee: number, dataIMG: string) {
    return this.http.post(this.url + "api/erp/payroll/personal/photo/" + idEmployee, dataIMG);
  }

  addID(idEmployee: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(this.url + "api/erp/payroll/personal/document/" + idEmployee, formData);
  }

  addPolicy(idEmployee: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(this.url + "api/erp/payroll/personal/policiacos/" + idEmployee, formData);
  }

  addPenal(idEmployee: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(this.url + "api/erp/payroll/personal/penales/" + idEmployee, formData);
  }

  addWorkContract(idEmployee: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(this.url + "api/erp/payroll/personal/workcontract/" + idEmployee, formData);
  }

  addPsicommetricTest(idEmployee: number, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(this.url + "api/erp/payroll/personal/psychometrictests/" + idEmployee, formData);
  }

  //
  hireEmployees(contracts:any){
    return this.http.post(this.url + "api/erp/payroll/contract", contracts);
  }

  rehireEmployees(contracts:any){
    return this.http.put(this.url + "api/erp/payroll/contract", contracts);
  }

  fireEmployees(employeeId: any, terminationDate: string) {
    const body = {
      terminationDate: terminationDate
    };

    return this.http.put(
      this.url + `api/erp/payroll/contract/fire-employees/${employeeId}`,
      body
    );
  }

  registerEmployee(employee:any){
    return this.http.post(this.url + "api/erp/payroll/personal/employee", employee);
  }
  
  updateEmployee(employee:any){
    return this.http.put(this.url + "api/erp/payroll/personal/employee/"+employee.id, employee);
  }

  uploadCsv(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(this.url + "api/erp/payroll/personal/csv", formData);
  }

  updateContractProfile(id: number ,contractProfile: ProfileSalaryRequest) {
    return this.http.put( `${this.url}api/erp/payroll/contract/profile/${id}`, contractProfile);
  }

  updateContractEmployee(contracts:any){
    return this.http.put(this.url + "api/erp/payroll/contract/update", contracts);
  }

  getHumanResourcesReportAnual(year: number, type: string) {
    return this.http.get(this.url + "api/erp/payroll/report/anual/" + year + "/" + type);
  }

  getHumanResourcesReportMonthlyComplete(year: number,month: number, type: string) {
    return this.http.get(this.url + "api/erp/payroll/report/monthly-complete/" + year + "/"+ month + "/" + type);
  }
}
